import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from '@app/shared/shared.module';
import { AuthModalComponent } from '@app/core/user/containers/auth-modal/auth-modal.component';
import { RegisterModule } from '@app/core/user/components/register/register.module';
import { LoginModule } from '@app/core/user/components/login/login.module';
import { PasswordResetModule } from '@app/core/user/components/password-reset/password-reset.module';
import { UserService } from '@app/core/user/services/user/user.service';
import { SvgModule } from '@app/shared/components/svg/svg.module';

import { LoginRegisterScreenComponent } from '@app/core/user/components/login-register-screen/login-register-screen.component';

@NgModule({
  imports: [CommonModule, RegisterModule, LoginModule, PasswordResetModule, MatDialogModule, SharedModule, SvgModule],
  declarations: [AuthModalComponent, LoginRegisterScreenComponent],
  exports: [AuthModalComponent],
  providers: [UserService],
  entryComponents: [AuthModalComponent]
})
export class AuthModalModule {}
